'use client';

import * as React from 'react';
import { Moon, Sun, Laptop, Check } from 'lucide-react';
import { useTheme } from 'next-themes';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function ModeToggle() {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => setMounted(true), []);

  const isSelected = (value: 'light' | 'dark' | 'system') => theme === value;

  const CurrentIcon = () => {
    if (!mounted) return <Sun className="h-[1.2rem] w-[1.2rem]" />;
    if (resolvedTheme === 'dark') return <Moon className="h-[1.2rem] w-[1.2rem]" />;
    if (resolvedTheme === 'light') return <Sun className="h-[1.2rem] w-[1.2rem]" />;
    return <Laptop className="h-[1.2rem] w-[1.2rem]" />;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="cursor-pointer relative">
          <CurrentIcon />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="min-w-[8.5rem]">
        <DropdownMenuItem
          onClick={() => setTheme('light')}
          className="cursor-pointer flex items-center gap-2"
        >
          <Sun className="h-4 w-4" />
          <span className="flex-1">Light</span>
          {isSelected('light') && <Check className="h-4 w-4 opacity-60" />}
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={() => setTheme('dark')}
          className="cursor-pointer flex items-center gap-2"
        >
          <Moon className="h-4 w-4" />
          <span className="flex-1">Dark</span>
          {isSelected('dark') && <Check className="h-4 w-4 opacity-60" />}
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={() => setTheme('system')}
          className="cursor-pointer flex items-center gap-2"
        >
          <Laptop className="h-4 w-4" />
          <span className="flex-1">System</span>
          {isSelected('system') && <Check className="h-4 w-4 opacity-60" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
